import styled from "styled-components";

export const CourseLandingPageContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    margin-bottom: 100px;
  }

  span.section-title-badge {
    color: ${({ theme }) => theme.colors.textMasterColor};
  }

  sup.ant-badge-count {
    background: ${({ theme }) => theme.colors.primary};

    span {
      color: ${({ theme }) => theme.colors.textMasterColor};
    }
  }

  .ant-btn-primary {
    &,
    span {
      color: ${({ theme }) => theme.colors.btnTextColor};
    }
  }

  .ant-card-head-title {
    text-transform: none;
  }

  .ant-btn,
  .ant-btn-primary,
  .ant-btn-primary:hover {
    color: ${({ theme }) => theme.colors?.btnTextColor} !important;
  }
`;
